export { default as MarketingCard } from './marketing-card';
export * from './types';
